import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getExhibitorDetails_action, updateExhibitorDetails_action } from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/exhibitor_details_action/exhibitor_details_action"
import { primaryChapterListActionId, toastError, toastSuccess, internationalAreaSlabActionId, countryActionId, stallTypeActionId, stallSizeActionId, openSideListActionId } from "../../../../../utils/constants";
import { getDetails_spaceBooking_action, edit_spaceBoking_action, updateSpacebookingEstimate_action } from "../../../../../actions/exhibitor_module_actions/space_booking_action/spaceBooking_action"
import Modal from "react-modal";
import { data } from "jquery";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import { fill_action } from "../../../../../actions/fillCombo_action";
import {
    getDoubleStoreySSI_action,
} from '../../../../../actions/primary_chapter_action'
import moment from "moment";

class ExhibitorDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            exhibitionID: "",
            exhRegistrationID: "",
            exbTableErr: '',
            stallArea: '',
            subChapters: [],
            level2: "",
            level3: "",
            level4: "",
            DeadlineDate: "",
            currentDate: moment().format('DD-MM-YYYY'),
            guideLines: [],
            isShowMachineryGuidelines: false,
            guidelinesAddress: '',
            Remark: '',
            StatusID: '',

            regCompany: '',
            fasciaName: '',
            otherPersonInchFirst: '',
            personInchFirst: '',
            preFixPersonInch: 'Mr',
            isOtherPreFixPersonInch: false,
            personInchLast: '',
            regDesignation: '',
            regCountry: '',
            primaryChapterName: '',
            stallTypeIdList: [],
            stallArea: '',
            stallAreaList: [],
            area: '',
            isChargesforOpenSides: false,
            openSideList: [],
            openSlides: '',
            stallTypeId: '',

            InternationalArea: '',
            InternationalAreaErr: '',
            exhibitDetailsTableErr: '',
            countryId: '',
            countryList: [],
            stallTypeIdList: [],
            openSideList: [],
            stallAreaList: [],
            stallArea: '',
            stallAreaName: '',
            stallArea: '',
            area: '',
            openSlides: '',
            stallTypeId: '',
            isDoubleStoreyExhibition: false,
            isDoubleStorey: false,
            doubleStoreyArea: '',
            DueDate: '',
            internationalAreaSlabList: [],
            oldInternationalArea: '',

            newestimateDetails: [],
            estimatePop: false,
            isUpdatePerm: false,
            ExhibitDetailsNote: [],
            minAreafor4OpenSide: 300
        }

        this.getExhibitorDetails = this.getExhibitorDetails.bind(this)
        this.updateExhibitorDetails = this.updateExhibitorDetails.bind(this)
        this.onEnterProductName = this.onEnterProductName.bind(this)
        this.onMachineDetailsChange = this.onMachineDetailsChange.bind(this)
        this.onEnterHSNCode = this.onEnterHSNCode.bind(this)
        this.onLengthChange = this.onLengthChange.bind(this)
        this.onBreadthChange = this.onBreadthChange.bind(this)
        this.onHeightChange = this.onHeightChange.bind(this)
        this.onFloorCapacityChange = this.onFloorCapacityChange.bind(this)
        this.onMachineWeightChange = this.onMachineWeightChange.bind(this)
        this.onManufacturerNameChange = this.onManufacturerNameChange.bind(this)
        this.maxLengthCheck = this.maxLengthCheck.bind(this)
        this.onAddClick = this.onAddClick.bind(this)
        this.onCheckLevel2 = this.onCheckLevel2.bind(this)
        this.record = this.record.bind(this)
        this.onSelectLevel4 = this.onSelectLevel4.bind(this)
        this.onCheckLevel3 = this.onCheckLevel3.bind(this)
        this.recordFour = this.recordFour.bind(this)
        this.onMBclick = this.onMBclick.bind(this)

    }

    componentDidMount() {
        this.setState({
            DeadlineDate: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.Deadline != "" ?
                moment(this.props.location.state.Deadline).format('DD-MM-YYYY') : '',
            StatusID: this.props.location.state != null && this.props.location.state != "" && this.props.location.state.StatusID != "" ?
                this.props.location.state.StatusID : '',
        })
        this.getFillList(internationalAreaSlabActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {
            setTimeout(() => {
                this.getExhibitorDetails()
                this.getDoubleStroeySSI()
            }, 200);
        })
        // this.getFillList(primaryChapterListActionId, '', '', '', '', '');

    }

    handleCancel() {
        this.props.navigate('/manualForms')
    }

    updateExhibitorDetails() {
        const { subChapters, exbTableErr, Remark, stallAreaName, area, InternationalArea } = this.state
        // Preparing SubChapter List For Udt 
        var list = []
        subChapters.map(data => {
            var data = {
                "ExhibitionID": parseInt(sessionStorage.getItem('sessionExhibitionID')),
                "ExhRegistrationID": sessionStorage.getItem('ExhRegistrationIDSS'),
                "ChapterID": data.ChapterID,
                'ChapterName': data.ChapterName,
                "HSNCode": data.HSNCode,
                "MachineDetails": data.MachineDetails,
                "Length": data.Length,
                "Breadth": data.Breadth,
                "Height": data.Height,
                "FloorCapacity": data.FloorCapacity,
                "MachineWeight": data.MachineWeight,
                "ManufacturerName": data.ManufacturerName,
                "ManufacturingCountry": data.ManufacturingCountry,
                'isMachine': data.isMachine,
                'isBrochure': data.isBrochure
            }
            list.push(data)
        })
        console.log("Ramark--", Remark)
        var iserror = false
        if (subChapters.length == 0) {
            console.log("exhibitDetailsList", subChapters)
            this.setState({
                exbTableErr: 'Please select atleast one chapter'
            })
            iserror = true
        }
        var lengthErr = ''
        if (exbTableErr != '') {
            console.log("exhibitDetailsList", subChapters)
            // this.setState({
            //     exhibitDetailsTableErr: 'Please select atleast one chapter'
            // })
            iserror = true
            lengthErr = exbTableErr
        }
        const isAllMB = subChapters.every(item => item.isMachine != undefined && item.isBrochure != undefined ? (item.isMachine || item.isBrochure) : false)
        subChapters.every(item => console.log(item.isMachine != undefined && item.isBrochure != undefined, (item.isMachine, item.isBrochure)))

        console.log(isAllMB)
        var DueDateValidation = false
        if (this.state.DueDate != '') {
            if (new Date(this.state.DueDate) < new Date()) {
                DueDateValidation = true
            }
        }
        var totalEnterSpace = 0
        for (var i = 0; i < subChapters.length; i++) {
            if (stallAreaName != null && stallAreaName != '' && subChapters[i].Length != null && subChapters[i].Length != '' && subChapters[i].Length != 0 &&
                subChapters[i].Breadth != null && subChapters[i].Breadth != '' && subChapters[i].Breadth != 0) {
                var currentArea = parseFloat(subChapters[i].Length) * parseFloat(subChapters[i].Breadth);
                totalEnterSpace = totalEnterSpace + currentArea
            }
            if (subChapters[i].Length == '' || subChapters[i].Length == 0 || subChapters[i].Length == null) {
                if (DueDateValidation && !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && !subChapters[i].isMachine && subChapters[i].isBrochure)) {
                    this.setState({
                        exbTableErr: "Please Enter all Length"
                    })
                    iserror = true
                    lengthErr = "Please Enter all Length"
                }
            } else if (subChapters[i].Breadth == '' || subChapters[i].Breadth == null || subChapters[i].Breadth == 0) {
                if (DueDateValidation && !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && !subChapters[i].isMachine && subChapters[i].isBrochure)) {
                    iserror = true
                    lengthErr = "Please Enter all Breadth"
                    this.setState({
                        exbTableErr: "Please Enter all Breadth"
                    })
                }
            } else if (subChapters[i].Height == '' || subChapters[i].Height == null || subChapters[i].Height == 0) {
                if (DueDateValidation && !(subChapters[i].isMachine != undefined && subChapters[i].isBrochure != undefined && !subChapters[i].isMachine && subChapters[i].isBrochure)) {
                    iserror = true
                    lengthErr = "Please Enter all Height"
                    this.setState({
                        exbTableErr: "Please Enter all Height"
                    })
                }
            } else if (!isAllMB) {
                iserror = true
                lengthErr = "Please Select Machine/Brochure"
                this.setState({
                    exbTableErr: "Please Select Machine/Brochure"
                })
            } else if (subChapters[i].ManufacturerName == '' || subChapters[i].ManufacturerName == null) {
                iserror = true
                lengthErr = "Please Enter all Manufacturer Name"
                this.setState({
                    exbTableErr: "Please Enter all Manufacturer Name"
                })
            } else if (subChapters[i].ManufacturingCountry == '' || subChapters[i].ManufacturingCountry == null) {
                this.setState({
                    exbTableErr: 'Please Select all Manufacturer Country'
                })
                iserror = true
                lengthErr = "Please Select all Manufacturer Country"

            }
        }
        if (totalEnterSpace > area) {
            iserror = true
            lengthErr = 'Length and breadth must be below or equal to stall area.'
            this.setState({ exbTableErr: 'Length and breadth must be below or equal to stall area.' })
        }
        if (iserror) {
            toastError(lengthErr != '' ? lengthErr : "Please fill mandatory fields")
            return
        }

        if (!iserror && exbTableErr == "") {
            if ((parseFloat(this.state.oldInternationalArea) != parseFloat(InternationalArea)) && !this.state.isUpdatePerm) {
                this.setState({ isLoading: true })
                this.props.updateSpacebookingEstimate_action(this.state.stallArea, this.state.area, this.state.stallTypeId, this.state.openSlides, this.state.isDoubleStorey, this.state.doubleStoreyArea != "" && this.state.doubleStoreyArea != null ? this.state.doubleStoreyArea : 0, this.state.InternationalArea != "" && this.state.InternationalArea != null ? this.state.InternationalArea : 0)
                    .then((data) => {
                        if (data.error != 1) {
                            console.log(data.data[0])
                            for (var i = 0; i < data.data[0].length; i++) {
                                if (data.data[0][i].Description.includes("--"))
                                    data.data[0][i].Description = data.data[0][i].Description.replace(/--/g, ' ')
                            }
                            this.setState({
                                newestimateDetails: data.data[0].length > 0 ? data.data[0] : '',
                                estimatePop: true
                            })
                            this.setState({ isLoading: false })

                        } else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    }).catch((err) => {
                        console.log(err)
                    })

            } else {
                this.setState({ isLoading: true })
                this.props.updateExhibitorDetails_action(list, Remark, this.state.InternationalArea != "" && this.state.InternationalArea != null ? this.state.InternationalArea : 0)
                    .then((data) => {
                        if (data.error != 1) {
                            console.log("updatedetails", data.data)
                            toastSuccess("Data Updated Successfully")
                            setTimeout(() => {
                                this.setState({ isLoading: false, isUpdatePerm: false, estimatePop: false })
                                this.handleCancel()
                            }, 300);
                        } else {
                            this.setState({ isLoading: false, isUpdatePerm: false, estimatePop: false })
                            toastError(data.msg)
                        }
                    }).catch((err) => {
                        console.log(err)
                    })
            }
        }
        else {
            toastError("Please Correct Length And Breadth Size")
        }
    }

    // Get Fill List
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        return new Promise((resolve, reject) => {

            this.setState({ isLoading: true })
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === primaryChapterListActionId) {
                            async function seqnoFormat(arr) {
                                for (var i = 0; i < arr.length; i++) {
                                    if (arr[i].seqno != '' && arr[i].seqno != null) {
                                        arr[i].ChapterName.trim()
                                        // console.log(arr[i].ChapterName)
                                        if (/^\d$/.test(arr[i].ChapterName[0])) {
                                            for (var j = 0; j < arr[i].ChapterName.length; j++) {
                                                if (arr[i].ChapterName[j] == ' ') {
                                                    var str = arr[i].ChapterName.slice(j)
                                                    var finalName = arr[i].seqno + str
                                                    arr[i].ChapterName = finalName
                                                    // console.log("primaryChapterListActionId 121212", i, finalName)
                                                    break
                                                }
                                            }
                                        } else {
                                            var str = arr[i].ChapterName
                                            var finalName = arr[i].seqno + ' ' + str
                                            arr[i].ChapterName = finalName
                                        }
                                    }
                                }
                                return
                            }
                            for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                for (var j = 0; j < data.data['primaryChapter'].length - 1 - i; j++) {
                                    var seq1 = data.data['primaryChapter'][j].seqno
                                    var seq2 = data.data['primaryChapter'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['primaryChapter'][j]
                                        data.data['primaryChapter'][j] = data.data['primaryChapter'][j + 1]
                                        data.data['primaryChapter'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                if (data.data['primaryChapter'][i].seqno == null || data.data['primaryChapter'][i].seqno == undefined) {
                                    console.log(data.data['primaryChapter'][i].seqno, i)
                                }
                                // seqnoFormat(data.data['primaryChapter'])
                            }
                            for (var i = 0; i < data.data['level2'].length; i++) {
                                for (var j = 0; j < data.data['level2'].length - 1 - i; j++) {
                                    var seq1 = data.data['level2'][j].seqno
                                    var seq2 = data.data['level2'][j + 1].seqno
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level2'][j]
                                        data.data['level2'][j] = data.data['level2'][j + 1]
                                        data.data['level2'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                if (data.data['level2'][i].seqno == null || data.data['level2'][i].seqno == undefined) {
                                    console.log(data.data['level2'][i].seqno, i)
                                }
                                seqnoFormat(data.data['level2'])
                            }
                            console.log("prr", data.data['level2'])
                            for (var i = 0; i < data.data['level3'].length; i++) {
                                for (var j = 0; j < data.data['level3'].length - 1 - i; j++) {

                                    var seq1 = data.data['level3'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level3'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')

                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level3'][j]
                                        data.data['level3'][j] = data.data['level3'][j + 1]
                                        data.data['level3'][j + 1] = temp;
                                    }
                                }
                                if (data.data['level3'][i].seqno == null || data.data['level3'][i].seqno == undefined) {
                                    console.log(data.data['level3'][i].seqno, i)
                                }
                                seqnoFormat(data.data['level3'])
                            }
                            for (var i = 0; i < data.data['level4'].length; i++) {
                                for (var j = 0; j < data.data['level4'].length - 1 - i; j++) {
                                    var seq1 = data.data['level4'][j].seqno
                                    seq1 = seq1 != null && seq1.replaceAll('.', '')
                                    var seq2 = data.data['level4'][j + 1].seqno
                                    seq2 = seq2 != null && seq2.replaceAll('.', '')
                                    if ((parseFloat(seq1) > parseFloat(seq2))) {
                                        var temp = data.data['level4'][j]
                                        data.data['level4'][j] = data.data['level4'][j + 1]
                                        data.data['level4'][j + 1] = temp;
                                        // console.log(i, j, arr[j])
                                    }
                                }
                                if (data.data['level4'][i].seqno == null || data.data['level4'][i].seqno == undefined) {
                                    console.log(data.data['level4'][i].seqno, i)
                                }
                                seqnoFormat(data.data['level4'])
                            }

                            for (var i = 0; i < data.data['level2'].length; i++) {
                                data.data['level2'][i].isHighlight = false;
                            }
                            this.setState({
                                primaryChapterListData: data.data['primaryChapter'],
                                level0: data.data['level0'],
                                level2: data.data['level2'],
                                level3: data.data['level3'],
                                level4: data.data['level4'],
                                isLoading: false,
                            })
                            setTimeout(() => {
                                this.filterLevelData()
                            }, 300);
                        }
                        if (actionID === countryActionId) {
                            console.log("country data", data.data)
                            this.setState({
                                countryList: data.data,
                                tempCountryList: data.data,
                                billTempCountryList: data.data,
                                isLoading: false,
                            })
                        }
                    }
                    if (actionID === stallTypeActionId) {
                        // console.log("country data", data.data)
                        this.setState({
                            stallTypeIdList: data.data,
                        })
                        if (data.data.length == 1) {
                            this.onstallTypeIdChange(null, data.data[0].Code)
                        }
                        // resolve(true)
                    }
                    if (actionID === internationalAreaSlabActionId) {
                        // console.log("country data", data.data)
                        this.setState({
                            internationalAreaSlabList: data.data,
                        })
                        resolve(true)
                    }
                    if (actionID === openSideListActionId) {
                        // console.log("country data", data.data)
                        this.setState({
                            openSideList: data.data,
                        })
                        // resolve(true)
                    }
                    // stall Size
                    if (actionID === stallSizeActionId) {
                        // console.log("country data", data.data)
                        this.setState({
                            stallAreaList: data.data,
                        })
                        if (this.state.stallArea != '') {
                            for (var i = 0; i < data.data.length; i++) {
                                if (data.data[i].Code == this.state.stallArea) {
                                    console.log('Description : ', data.data[i].Description);
                                    this.setState({ stallAreaName: data.data[i].Description })
                                }
                            }
                        }
                        // resolve(true)
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    filterLevelData() {
        const { level2, level3, level4 } = this.state
        var newLevel = [...level2]
        for (var i = 0; i < level3.length; i++) {
            var tempLevel4 = [];
            for (var j = 0; j < level4.length; j++) {
                if (level3[i]['ChapterID'] == level4[j]['ParentChapterID']) {
                    tempLevel4.push(level4[j]);
                }
            }
            level3[i]['level_four_List'] = tempLevel4;
            // console.log(" level3[i]['level_four_List']", tempLevel4);
        }

        for (var i = 0; i < newLevel.length; i++) {
            var tempLevel3 = [];
            for (var j = 0; j < level3.length; j++) {
                if (newLevel[i]['ChapterID'] == level3[j]['ParentChapterID']) {
                    tempLevel3.push(level3[j]);
                }
            }
            newLevel[i]['level_third_List'] = tempLevel3;
            // console.log("level2[i]['level_third_List']", tempLevel3);

        }

        ///////////============
        console.log("level2", newLevel)
        this.setState({ level2: newLevel })
    }

    // Get  Details
    getExhibitorDetails() {
        this.setState({ isLoading: true })
        this.props.getExhibitorDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Get details", data.data)

                    this.setState({
                        Remark: data.data['primaryChapterHeaderDetails'][0]['Remark'],
                        isDoubleStoreyExhibition: JSON.parse(sessionStorage.getItem('isDoubleStoreyExhibition')),
                    })
                    const countryId = data.data['registrationDetails'][0]['CountryID'] ? data.data['registrationDetails'][0]['CountryID'] : ''
                    this.getFillList(countryActionId, '', '', countryId, '', '');
                    this.getFillList(stallTypeActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')
                    this.getFillList(openSideListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '')

                    var minAreaAsModule = 0
                    for (var i = 0; i < this.state.subChapters.length; i++) {
                        if (parseInt(data.data['primaryChapterHeaderDetails'][0].StallTypeID) == 1) {
                            console.log('subChapters[i].MinBareArea', this.state.subChapters[i].MinBareArea)
                            if (this.state.subChapters[i].MinBareArea != '' && this.state.subChapters[i].MinBareArea != null) {
                                if (minAreaAsModule < this.state.subChapters[i].MinBareArea) {
                                    minAreaAsModule = this.state.subChapters[i].MinBareArea
                                }
                            }
                        } else if (parseInt(data.data['primaryChapterHeaderDetails'][0].StallTypeID) == 2) {
                            if (this.state.subChapters[i].MinShellArea != '' && this.state.subChapters[i].MinShellArea != null) {
                                if (minAreaAsModule < this.state.subChapters[i].MinShellArea) {
                                    minAreaAsModule = this.state.subChapters[i].MinShellArea
                                }
                            }
                        }
                    }
                    console.log("level2.length00000000000000000", parseInt(data.data['primaryChapterHeaderDetails'][0].StallTypeID), minAreaAsModule, this.state.subChapters)
                    for (var i = 0; i < data.data['estimateNote'].length; i++) {
                        if (data.data['estimateNote'][i].NoteType == 'exhibit details') {
                            this.state.ExhibitDetailsNote.push(data.data['estimateNote'][i])
                        }
                    }
                    this.getFillList(stallSizeActionId, sessionStorage.getItem("sessionExhibitionID"), minAreaAsModule == 0 ? '' : minAreaAsModule, data.data['primaryChapterHeaderDetails'][0].StallTypeID, countryId, '')

                    // Chapter Level 2 Level 3 And Level 4
                    var allChap = []
                    const lev2 = data.data['primaryChapterListDetails']['level2'].filter(obj => obj.IsSelect == true)
                    allChap.push(...lev2)
                    const lev3 = data.data['primaryChapterListDetails']['level3'].filter(obj => obj.IsSelect == true)
                    allChap.push(...lev3)
                    const lev4 = data.data['primaryChapterListDetails']['level4'].filter(obj => obj.IsSelect == true)
                    allChap.push(...lev4)

                    // Primary Chapter Stall Area
                    const primaryChapterStallArea = data.data['primaryChapterHeaderDetails'][0].ExhibitionStallSizeID

                    // Only Sub Chapters
                    const finalSubChap = allChap.filter(element => element.IsCheckbox == true)
                    console.log("final chapters", finalSubChap)

                    // Setting chapters
                    const { level2, level3, level4, internationalAreaSlabList } = this.state
                    console.log("111->>>>>>>>>>>>>>>>>>>>>", level2)
                    console.log("222->>>>>>>>>>>>>>>>>>>>>", level3)
                    console.log("333->>>>>>>>>>>>>>>>>>>>>", level4)
                    level2.length > 0 && level2.map((data) => {
                        finalSubChap.length > 0 && finalSubChap.map((item) => {
                            if (data.ChapterID == item.ChapterID) {
                                data.IsSelect = true
                            }
                        })
                    })

                    level3.length > 0 && level3.map((data) => {
                        finalSubChap.length > 0 && finalSubChap.map((item) => {
                            if (data.ChapterID == item.ChapterID) {
                                data.IsSelect = true
                            }
                        })
                    })

                    level4.length > 0 && level4.map((data) => {
                        finalSubChap.length > 0 && finalSubChap.map((item) => {
                            if (data.ChapterID == item.ChapterID) {
                                data.IsSelect = true
                            }
                        })
                    })
                    // ------
                    async function seqnoFormat(arr) {
                        for (var i = 0; i < arr.length; i++) {
                            if (arr[i].seqno != '' && arr[i].seqno != null) {
                                arr[i].ChapterName.trim()
                                // console.log(arr[i].ChapterName)
                                if (/^\d$/.test(arr[i].ChapterName[0])) {
                                    for (var j = 0; j < arr[i].ChapterName.length; j++) {
                                        if (arr[i].ChapterName[j] == ' ') {
                                            var str = arr[i].ChapterName.slice(j)
                                            var finalName = arr[i].seqno + str
                                            arr[i].ChapterName = finalName
                                            // console.log("primaryChapterListActionId 121212", i, finalName)
                                            break
                                        }
                                    }
                                } else {
                                    var str = arr[i].ChapterName
                                    var finalName = arr[i].seqno + ' ' + str
                                    arr[i].ChapterName = finalName
                                }
                            }
                        }
                        return
                    }
                    for (var i = 0; i < data.data['primaryChapterListDetails']['primaryChapter'].length; i++) {
                        for (var j = 0; j < data.data['primaryChapterListDetails']['primaryChapter'].length - 1 - i; j++) {
                            var seq1 = data.data['primaryChapterListDetails']['primaryChapter'][j].seqno
                            var seq2 = data.data['primaryChapterListDetails']['primaryChapter'][j + 1].seqno
                            if ((parseFloat(seq1) > parseFloat(seq2))) {
                                var temp = data.data['primaryChapterListDetails']['primaryChapter'][j]
                                data.data['primaryChapterListDetails']['primaryChapter'][j] = data.data['primaryChapterListDetails']['primaryChapter'][j + 1]
                                data.data['primaryChapterListDetails']['primaryChapter'][j + 1] = temp;
                                // console.log(i, j, arr[j])
                            }
                        }
                        if (data.data['primaryChapterListDetails']['primaryChapter'][i].seqno == null || data.data['primaryChapterListDetails']['primaryChapter'][i].seqno == undefined) {
                            console.log(data.data['primaryChapterListDetails']['primaryChapter'][i].seqno, i)
                        }
                        // seqnoFormat(data.data['primaryChapterListDetails']['primaryChapter'])
                    }
                    for (var i = 0; i < data.data['primaryChapterListDetails']['level2'].length; i++) {
                        for (var j = 0; j < data.data['primaryChapterListDetails']['level2'].length - 1 - i; j++) {
                            var seq1 = data.data['primaryChapterListDetails']['level2'][j].seqno
                            var seq2 = data.data['primaryChapterListDetails']['level2'][j + 1].seqno
                            if ((parseFloat(seq1) > parseFloat(seq2))) {
                                var temp = data.data['primaryChapterListDetails']['level2'][j]
                                data.data['primaryChapterListDetails']['level2'][j] = data.data['primaryChapterListDetails']['level2'][j + 1]
                                data.data['primaryChapterListDetails']['level2'][j + 1] = temp;
                                // console.log(i, j, arr[j])
                            }
                        }
                        if (data.data['primaryChapterListDetails']['level2'][i].seqno == null || data.data['primaryChapterListDetails']['level2'][i].seqno == undefined) {
                            console.log(data.data['primaryChapterListDetails']['level2'][i].seqno, i)
                        }
                        seqnoFormat(data.data['primaryChapterListDetails']['level2'])
                    }
                    // console.log("prr", data.data['level2'])
                    for (var i = 0; i < data.data['primaryChapterListDetails']['level3'].length; i++) {
                        for (var j = 0; j < data.data['primaryChapterListDetails']['level3'].length - 1 - i; j++) {

                            var seq1 = data.data['primaryChapterListDetails']['level3'][j].seqno
                            seq1 = seq1 != null && seq1.replaceAll('.', '')
                            var seq2 = data.data['primaryChapterListDetails']['level3'][j + 1].seqno
                            seq2 = seq2 != null && seq2.replaceAll('.', '')

                            if ((parseFloat(seq1) > parseFloat(seq2))) {
                                var temp = data.data['primaryChapterListDetails']['level3'][j]
                                data.data['primaryChapterListDetails']['level3'][j] = data.data['primaryChapterListDetails']['level3'][j + 1]
                                data.data['primaryChapterListDetails']['level3'][j + 1] = temp;
                            }
                        }
                        if (data.data['primaryChapterListDetails']['level3'][i].seqno == null || data.data['primaryChapterListDetails']['level3'][i].seqno == undefined) {
                            console.log(data.data['primaryChapterListDetails']['level3'][i].seqno, i)
                        }
                        seqnoFormat(data.data['primaryChapterListDetails']['level3'])
                    }
                    for (var i = 0; i < data.data['primaryChapterListDetails']['level4'].length; i++) {
                        for (var j = 0; j < data.data['primaryChapterListDetails']['level4'].length - 1 - i; j++) {
                            var seq1 = data.data['primaryChapterListDetails']['level4'][j].seqno
                            seq1 = seq1 != null && seq1.replaceAll('.', '')
                            var seq2 = data.data['primaryChapterListDetails']['level4'][j + 1].seqno
                            seq2 = seq2 != null && seq2.replaceAll('.', '')
                            if ((parseFloat(seq1) > parseFloat(seq2))) {
                                var temp = data.data['primaryChapterListDetails']['level4'][j]
                                data.data['primaryChapterListDetails']['level4'][j] = data.data['primaryChapterListDetails']['level4'][j + 1]
                                data.data['primaryChapterListDetails']['level4'][j + 1] = temp;
                                // console.log(i, j, arr[j])
                            }
                        }
                        if (data.data['primaryChapterListDetails']['level4'][i].seqno == null || data.data['primaryChapterListDetails']['level4'][i].seqno == undefined) {
                            console.log(data.data['primaryChapterListDetails']['level4'][i].seqno, i)
                        }
                        seqnoFormat(data.data['primaryChapterListDetails']['level4'])
                    }

                    for (var i = 0; i < data.data['primaryChapterListDetails']['level2'].length; i++) {
                        data.data['primaryChapterListDetails']['level2'][i].isHighlight = false;
                    }

                    var exhibitlist = []
                    // console.log("level2 get", level2)
                    data.data['primaryChapterListDetails']['level2'].length > 0 && data.data['primaryChapterListDetails']['level2'].map(level2Data => {
                        if (level2Data.IsSelect && level2Data.IsCheckbox) {
                            // console.log("level2Data get", level2Data)
                            level2Data.Area = parseFloat(level2Data.Length || 0) * parseFloat(level2Data.Breadth || 0)
                            exhibitlist.push(level2Data)
                        }
                    })
                    data.data['primaryChapterListDetails']['level3'].length > 0 && data.data['primaryChapterListDetails']['level3'].map(level3Data => {
                        if (level3Data.IsSelect && level3Data.IsCheckbox) {
                            level3Data.Area = parseFloat(level3Data.Length || 0) * parseFloat(level3Data.Breadth || 0)
                            exhibitlist.push(level3Data)
                        }
                    })
                    data.data['primaryChapterListDetails']['level4'].length > 0 && data.data['primaryChapterListDetails']['level4'].map(level4Data => {
                        if (level4Data.IsSelect && level4Data.IsCheckbox) {
                            level4Data.Area = parseFloat(level4Data.Length || 0) * parseFloat(level4Data.Breadth || 0)
                            exhibitlist.push(level4Data)
                        }
                    })
                    exhibitlist.sort((a, b) => (a.ChapterID > b.ChapterID) ? 1 : -1);
                    data.data['primaryChapterListDetails']['level0'].length > 0 && data.data['primaryChapterListDetails']['level0'].map(level0Data => {
                        if (level0Data.IsSelect) {
                            // console.log("level2Data get", level2Data)
                            level0Data.Area = parseFloat(level0Data.Length || 0) * parseFloat(level0Data.Breadth || 0)
                            exhibitlist.push(level0Data)
                        }
                    })
                    const totalArea = exhibitlist.reduce((sum, obj) => sum + obj.Area, 0)
                    if (data.data['primaryChapterHeaderDetails'][0].StallArea < totalArea) {
                        this.setState({ exbTableErr: 'Total area of sum cannot be greater than stall area' })
                    } else {
                        this.setState({ exbTableErr: '' })
                    }
                    console.log('exhibitlist==', exhibitlist)
                    const filterArray = exhibitlist.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    if (filterArray.length > 0) {
                        for (var i = 0; i < internationalAreaSlabList.length; i++) {
                            console.log(data.data['primaryChapterHeaderDetails'][0].StallArea, total)
                            if (internationalAreaSlabList[i].FromRange < data.data['primaryChapterHeaderDetails'][0].StallArea && data.data['primaryChapterHeaderDetails'][0].StallArea <= internationalAreaSlabList[i].ToRange) {
                                if (total >= internationalAreaSlabList[i].MinArea) {
                                    total = total
                                } else {
                                    total = internationalAreaSlabList[i].MinArea
                                }
                            }
                        }
                    }

                    this.setState({ subChapters: exhibitlist, isShowInternationalArea: filterArray.length > 0, InternationalArea: filterArray.length > 0 ? total : 0 })

                    this.setState({
                        isLoading: false,
                        subChapters: finalSubChap,
                        stallArea: primaryChapterStallArea,
                        countryId: data.data['registrationDetails'][0]['CountryID'] != null ? data.data['registrationDetails'][0]['CountryID'] : '',
                        regCompany: data.data['registrationDetails'][0]['CompanyName'] != null ? data.data['registrationDetails'][0]['CompanyName'] : '',
                        fasciaName: data.data['registrationDetails'][0]['FasciaName'] != null ? data.data['registrationDetails'][0]['FasciaName'] : '',
                        personInchFirst: data.data['registrationDetails'][0]['PersonIncharge'] != null ? data.data['registrationDetails'][0]['PersonIncharge'] : '',
                        personInchLast: data.data['registrationDetails'][0]['LastNamePersonIncharge'] != null ? data.data['registrationDetails'][0]['LastNamePersonIncharge'] : '',
                        regDesignation: data.data['registrationDetails'][0]['Designation'] != null ? data.data['registrationDetails'][0]['Designation'] : '',
                        primaryChapterName: data.data['registrationDetails'][0]['PrimaryChapterName'] != null && data.data['registrationDetails'][0]['PrimaryChapterName'] != '' ? data.data['registrationDetails'][0]['PrimaryChapterName'] : '',
                        level2: data.data['primaryChapterListDetails']['level2'].length > 0 ? data.data['primaryChapterListDetails']['level2'] : [],
                        level3: data.data['primaryChapterListDetails']['level3'].length > 0 ? data.data['primaryChapterListDetails']['level3'] : [],
                        level4: data.data['primaryChapterListDetails']['level4'].length > 0 ? data.data['primaryChapterListDetails']['level4'] : [],
                        stallArea: primaryChapterStallArea,
                        area: data.data['primaryChapterHeaderDetails'][0].StallArea,
                        openSlides: data.data['primaryChapterHeaderDetails'][0].OpenSidesID,
                        stallTypeId: data.data['primaryChapterHeaderDetails'].length > 0 ? data.data['primaryChapterHeaderDetails'][0].StallTypeID : '',
                        Remark: data.data['descriptionDetails'].length > 0 ? data.data['descriptionDetails'][0].Comment : '',
                        isDoubleStorey: data.data['primaryChapterHeaderDetails'][0].isDoubleStorey,
                        doubleStoreyArea: data.data['primaryChapterHeaderDetails'][0].DoubleStoreyArea,

                    })
                    console.log(allChap)
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    // On Change Of Product Name In Exhibit Table
    onEnterProductName(e, index) {
        const { level4, subChapters } = this.state

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("e.target.value", e.target.value)
                data.ChapterName = e.target.value
            }
        })

        subChapters.map((data, i) => {

        })

        for (var i = 0; i < subChapters.length; i++) {
            console.log("onEnterProductName validate : ", index, ' ', i, ' ', subChapters[i].ChapterName.toString().trim().toLowerCase(), ' ', e.target.value.toString().trim().toLowerCase())
            if (index != i && subChapters[i].ChapterName.toString().trim().toLowerCase() == e.target.value.toString().trim().toLowerCase()) {
                this.setState({ exbTableErr: 'Product name must be unique.' })
                return;
            } else {
                this.setState({ exbTableErr: '' })
            }
        }


        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters })

        }, 200);
    }

    // On Machine Details Change In Exhibit Table
    onMachineDetailsChange(e, id, index) {
        const { level4, subChapters } = this.state
        subChapters.map((data, i) => {
            if (index == i) {
                data.MachineDetails = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters })
        }, 100);
    }

    // On HSN No Change In Exhibit Table
    onEnterHSNCode(e, id, index) {
        const { level4, subChapters } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (index == i) {
                console.log("data.ChapterID", data.ChapterID)
                console.log("e.target.value", e.target.value)
                data.HSNCode = e.target.value
            }
        })
        setTimeout(() => {
            console.log("subChapters", subChapters)
            this.setState({ subChapters: subChapters })

        }, 200);
    }

    // On Length Change In Exhibit Table
    onLengthChange(e, id, index) {
        const { level4, subChapters, stallAreaName, area, internationalAreaSlabList } = this.state
        var breadth = 0;
        subChapters.map((data, i) => {
            if (index == i) {
                data.Length = e.target.value.replace(/[^0-9]/g, '')
                breadth = data.Breadth;
                data.Area = parseFloat(data.Length || 0) * parseFloat(data.Breadth || 0)
            }
        })
        const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        for (var i = 0; i < internationalAreaSlabList.length; i++) {
            console.log(area, total)
            if (internationalAreaSlabList[i].FromRange < area && area <= internationalAreaSlabList[i].ToRange) {
                if (total >= internationalAreaSlabList[i].MinArea) {
                    total = total
                } else {
                    total = internationalAreaSlabList[i].MinArea
                }
            }
        }
        setTimeout(() => {
            if (filterArray.length > 0) {
                this.setState({ InternationalArea: total })
            } else {
                this.setState({ InternationalArea: 0 })
            }
            this.setState({ subChapters: subChapters })
        }, 100);

        if (stallAreaName != null && stallAreaName != '' && e.target.value != null && e.target.value != '' && e.target.value != 0 &&
            breadth != null && breadth != 0) {
            var totalSpace;
            var totalEnterSpace;
            var lengthWidthList
            if (stallAreaName.includes('x')) {
                lengthWidthList = stallAreaName.split('x');
            } else if (stallAreaName.includes('X')) {
                lengthWidthList = stallAreaName.split('X');
            }
            totalSpace = parseFloat(lengthWidthList[0]) * parseFloat(lengthWidthList[1]);
            totalEnterSpace = parseFloat(e.target.value) * parseFloat(breadth);
            if (totalEnterSpace > totalSpace) {
                this.setState({ exbTableErr: 'Length and breadth must be below or equal to stall area.' })
            } else {
                this.setState({ exbTableErr: '' })
            }
        }

    }

    onBreadthChange(e, id, index) {
        const { level4, subChapters, stallAreaName, area, internationalAreaSlabList } = this.state
        var length = 0;
        subChapters.map((data, i) => {
            if (index == i) {
                data.Breadth = e.target.value.replace(/[^0-9]/g, '')
                length = data.Length;
                data.Area = parseFloat(data.Length || 0) * parseFloat(data.Breadth || 0)
            }
        })


        if (stallAreaName != null && stallAreaName != '' && e.target.value != null && e.target.value != '' && e.target.value != 0 &&
            length != null && length != 0) {
            var totalSpace;
            var totalEnterSpace;
            var lengthWidthList
            if (stallAreaName.includes('x')) {
                lengthWidthList = stallAreaName.split('x');
            } else if (stallAreaName.includes('X')) {
                lengthWidthList = stallAreaName.split('X');
            }

            totalSpace = parseFloat(lengthWidthList[0]) * parseFloat(lengthWidthList[1]);
            console.log('totalSpace : ', totalSpace);
            totalEnterSpace = parseFloat(e.target.value) * parseFloat(length);
            if (totalEnterSpace > totalSpace) {
                subChapters.map((data, i) => {
                    if (index == i) {
                        data.isLengthValidate = true;
                    }
                })
                this.setState({ exbTableErr: 'Length and breadth must be below or equal to stall area.' })
            } else {
                subChapters.map((data, i) => {
                    if (index == i) {
                        data.isLengthValidate = false;
                    }
                })
                this.setState({ exbTableErr: '' })
            }
        }
        const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
        for (var i = 0; i < internationalAreaSlabList.length; i++) {
            if (internationalAreaSlabList[i].FromRange < area && area <= internationalAreaSlabList[i].ToRange) {
                if (total >= internationalAreaSlabList[i].MinArea) {
                    total = total
                } else {
                    total = internationalAreaSlabList[i].MinArea
                }
            }
        }
        setTimeout(() => {
            if (filterArray.length > 0) {
                this.setState({ InternationalArea: total })
            } else {
                this.setState({ InternationalArea: 0 })
            }
            this.setState({ subChapters: subChapters, })
        }, 100);
    }

    onHeightChange(e, id, index) {
        const { level4, subChapters } = this.state
        subChapters.map((data, i) => {
            if (index == i) {
                data.Height = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters })
        }, 100);

        // if (e.target.value != null && e.target.value != '' && e.target.value != 0 && e.target.value > 3) {
        //     this.setState({ lengthWidthErr: 'Height must be less than or equal to 3.' })
        // } else {
        //     this.setState({ lengthWidthErr: '' })
        // }
    }

    onFloorCapacityChange(e, id, index) {
        const { level4, subChapters } = this.state
        subChapters.map((data, i) => {
            if (index == i) {
                data.FloorCapacity = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters })
        }, 100);
    }

    onMachineWeightChange(e, id, index) {
        const { level4, subChapters } = this.state
        subChapters.map((data, i) => {
            if (index == i) {
                data.MachineWeight = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters })
        }, 100);
    }

    onManufacturerNameChange(e, id, index) {
        const { level4, subChapters } = this.state
        subChapters.map((data, i) => {
            if (index == i) {
                data.ManufacturerName = e.target.value
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters })
        }, 100);
    }

    // On Manufacturing Country Name Change
    onManufacturingCountryChange(e, id, index) {
        const { countryList, tempCountryList, subChapters } = this.state;

        subChapters.map((data, i) => {
            if (index == i) {
                if (e.target.value != "") {
                    var searchStateList = tempCountryList.filter((data) => {
                        return data.Description.toLowerCase().includes(
                            e.target.value.toLowerCase()
                        );
                    });
                    data.ManufacturingCountry = e.target.value
                    this.setState({
                        tempCountryList: searchStateList,
                        isDisplayCountryList: true,
                        manufactureCountryIndex: index
                    });
                } else {
                    data.ManufacturingCountry = e.target.value
                    this.setState({
                        tempCountryList: countryList,
                        isDisplayCountryList: false,
                        manufactureCountryIndex: index
                    });
                }
            }
        })
        setTimeout(() => {
            this.setState({ subChapters: subChapters, exbTableErr: '' })
        }, 100);

    }

    renderCountryList() {
        const { countryList, tempCountryList } = this.state;
        return (
            <ul
                class="list-group pincode-drop"
                style={{ position: "absolute", zIndex: 1 }}
            >
                {tempCountryList.length > 0 &&
                    tempCountryList.map((data) => (
                        <li
                            class="list-group-item"
                            key={Math.random()}
                            onClick={(e) => this.callCountryList(data.Description, data.Code)}
                        >
                            {data.Description}
                        </li>
                    ))}
            </ul>
        );
    }

    callCountryList(value, id) {
        const { manufactureCountryIndex, subChapters, area, internationalAreaSlabList } = this.state
        subChapters.map((data, i) => {
            if (manufactureCountryIndex == i) {
                data.ManufacturingCountry = value
            }
        })
        const totalArea = subChapters.reduce((sum, obj) => sum + obj.Area, 0)
        if (area < totalArea) {
            this.setState({ exbTableErr: 'Total area of sum cannot be greater than stall area' })
        } else {
            this.setState({ exbTableErr: '' })
        }
        const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
        var total = filterArray.reduce((sum, obj) => (obj.isMachine ? obj.Area : 0), 0)
        const flag = subChapters.every(item => item.ManufacturingCountry.toLowerCase().trim() == JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim())
        console.log("subChapters--------------->", filterArray, total, flag)
        for (var i = 0; i < internationalAreaSlabList.length; i++) {
            if (internationalAreaSlabList[i].FromRange < area && area <= internationalAreaSlabList[i].ToRange) {
                if (total >= internationalAreaSlabList[i].MinArea) {
                    total = total
                } else {
                    total = internationalAreaSlabList[i].MinArea
                }
            }
        }
        // console.log("flag--------------->",flag)
        if (filterArray.length > 0) {
            this.setState({ InternationalArea: total })
        } else {
            this.setState({ InternationalArea: 0 })
        }
        setTimeout(() => {
            this.setState({ subChapters: subChapters, isShowInternationalArea: filterArray.length > 0 })
        }, 100);
        this.setState({ isDisplayCountryList: false, exbTableErr: '' });
        this.getFillList(countryActionId, "", "", "", "", "", "");
    }

    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    // On Cancel Click
    onCancelClick() {
        this.props.navigate('/manualForms')
    }

    // On Add click
    onAddClick(e) {
        e.preventDefault()
        const { isOpen } = this.state
        this.setState({ isOpen: !isOpen })
    }

    // on check level 2
    onCheckLevel2(e, id) {
        const { level2, subChapters, exbTableErr } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level2.length; i++) {
            if (level2[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!subChapters.includes(level2[i])) {
                        level2[i].isLengthValidate = false;
                        subChapters.push(level2[i])
                        this.setState({ subChapters: subChapters })
                    }
                }
                else {
                    this.setState({ subChapters: subChapters.filter(item => item.ChapterID != level2[i]['ChapterID']) })
                }

                level2[i]['IsSelect'] = !level2[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ level2: level2, exbTableErr: '' })
        }, 200);
    }

    // on check level 3
    onCheckLevel3(e, id) {
        const { level3, subChapters } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level3.length; i++) {
            if (level3[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!subChapters.includes(level3[i])) {
                        level3[i].isLengthValidate = false;
                        subChapters.push(level3[i])
                        this.setState({ subChapters: subChapters })
                    }
                }
                else {
                    this.setState({ subChapters: subChapters.filter(item => item.ChapterID != level3[i]['ChapterID']) })
                }

                level3[i]['IsSelect'] = !level3[i]['IsSelect']
            }
        }
        setTimeout(() => {
            this.setState({ level3: level3, exbTableErr: '' })
        }, 200);
    }

    getDoubleStroeySSI() {

        this.setState({ isLoading: true });
        const exhRegistrationID = sessionStorage.getItem('ExhRegistrationIDSS')
        const exhibitionID = sessionStorage.getItem('sessionExhibitionID')

        this.props
            .getDoubleStoreySSI_action(exhRegistrationID, exhibitionID)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {

                        var guideLines = []
                        for (var i = 0; i < data.data[1].length; i++) {
                            if (data.data[1][i].NoteType == 'Guidelines') {
                                guideLines.push(data.data[1][i])
                            }
                        }
                        this.setState({
                            guideLines: guideLines,
                            isShowMachineryGuidelines: data.data[0][0].isShowMachineryGuidelines,
                            guidelinesAddress: data.data[0][0].Address,
                            DueDate: data.data[0][0].DueDate,

                        })
                        this.setState({ isLoading: false })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    onMBclick(mode, id, index) {
        const { level4, exhibitDetailsList, subChapters, internationalAreaSlabList, area } = this.state
        console.log("id", id)

        subChapters.map((data, i) => {
            if (data.ChapterID == id) {
                if (mode == 0) {
                    if (data.isMachine) {
                        data.isMachine = false
                    } else {
                        data.isMachine = true
                    }
                } else if (mode == 1) {
                    if (data.isBrochure) {
                        data.isBrochure = false
                    } else {
                        data.isBrochure = true
                    }
                }
            }
        })
        setTimeout(() => {
            console.log("exhibitDetailsList", subChapters)
            this.setState({ subChapters: subChapters, exbTableErr: '' }
                , () => {
                    const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india' && item.ManufacturingCountry != '')
                    var total = filterArray.reduce((sum, obj) => sum + (obj.isMachine ? obj.Area : 0), 0)
                    for (var i = 0; i < internationalAreaSlabList.length; i++) {
                        if (internationalAreaSlabList[i].FromRange < area && area <= internationalAreaSlabList[i].ToRange) {
                            if (total >= internationalAreaSlabList[i].MinArea) {
                                total = total
                            } else {
                                total = internationalAreaSlabList[i].MinArea
                            }
                        }
                    }
                    setTimeout(() => {
                        if (filterArray.length > 0) {
                            this.setState({ InternationalArea: total })
                        } else {
                            this.setState({ InternationalArea: 0 })
                        }
                        subChapters.map((data, i) => {
                            if (data.ChapterID == id) {
                                if (!data.isMachine) {
                                    data.Length = 0
                                    data.Height = 0
                                    data.Breadth = 0
                                    data.Area = 0
                                }
                            }
                        })
                        setTimeout(() => {
                            this.setState({ subChapters: subChapters })
                        }, 100);
                    }, 100);
                }
            )

        }, 200);


    }

    // to call level third list 
    record(level2, level3, level4) {
        // var newdata = JSON.stringify(data);
        var tempLevel3 = [];
        for (var j = 0; j < level3.length; j++) {
            if (level2.ChapterID == level3[j]['ParentChapterID']) {
                tempLevel3.push(level3[j]);
            }
        }
        return (
            <>
                <div id={'collapse_l1_' + level2.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l1_' + level2.ChapterID} data-bs-parent="#accordionExample">
                    {
                        tempLevel3 && tempLevel3.map(level3data => {
                            return (
                                <div class="accordion-body">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id={'heading_l2_' + level3data.ChapterID}>
                                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={'#collapse_l2_' + level3data.ChapterID} aria-expanded="false" aria-controls={'collapse_l2_' + level3data.ChapterID}>
                                                {/* // checkbox for level3 */}
                                                {
                                                    level3data.IsCheckbox && <input type="checkbox" className="from-left-sp"
                                                        name="" key={level3data.ChapterID} checked={level3data.IsSelect}
                                                        onClick={e => this.onCheckLevel3(e, level3data.ChapterID)}
                                                    />
                                                }

                                                {level3data.ChapterName} </button>
                                        </h2>
                                        {this.recordFour(level3data, level4)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </>
        );
    }

    // on check level 4
    onSelectLevel4(e, id) {
        const { level4, subChapters } = this.state
        var tempExhibitDetailsList = []
        for (let i = 0; i < level4.length; i++) {
            if (level4[i]['ChapterID'] == id) {

                if (e.target.checked) {
                    if (!subChapters.includes(level4[i])) {
                        level4[i].isLengthValidate = false;
                        subChapters.push(level4[i])
                        this.setState({ subChapters: subChapters })
                    }
                }
                else {
                    this.setState({ subChapters: subChapters.filter(item => item.ChapterID != level4[i]['ChapterID']) })
                }

                level4[i]['IsSelect'] = !level4[i]['IsSelect']
            }
        }
        setTimeout(() => {
            console.log("xxxxxxxxxxxxxxxxxxxxxxxxx", subChapters)
            this.setState({ level4: level4, exbTableErr: '' })
        }, 200);

    }

    // to call level four list
    recordFour(level3data, level4) {
        var tempLevel4 = [];
        for (var j = 0; j < level4.length; j++) {
            if (level3data.ChapterID == level4[j]['ParentChapterID']) {
                tempLevel4.push(level4[j]);
            }
        }
        return (<>
            <div id={'collapse_l2_' + level3data.ChapterID} class="accordion-collapse collapse" aria-labelledby={'heading_l2_' + level3data.ChapterID}>
                {
                    tempLevel4 && tempLevel4.map(level4data => {
                        return (
                            <div class="accordion-body third-step">
                                {/* level4data.IsCheckbox && */}
                                <input type="checkbox" name="" key={level4data.ChapterID} checked={level4data.IsSelect}
                                    onClick={(e) => this.onSelectLevel4(e, level4data.ChapterID)} />
                                {level4data.ChapterName}
                            </div>
                        )
                    })
                }
            </div>
        </>);
    }


    render() {
        const { subChapters, stallTypeId, isLoading, exbTableErr, isOpen, level2, level3, level4, DeadlineDate, currentDate, guideLines, isShowMachineryGuidelines, guidelinesAddress, Remark, StatusID, regCompany, fasciaName, otherPersonInchFirst, personInchFirst, preFixPersonInch, isOtherPreFixPersonInch, personInchLast, regDesignation, regCountry, primaryChapterName, stallTypeIdList, InternationalArea, InternationalAreaErr, exhibitDetailsTableErr, stallArea, stallAreaList, area, isChargesforOpenSides, ExhibitDetailsNote, openSideList, openSlides, countryId, isDoubleStoreyExhibition, isDoubleStorey, doubleStoreyArea } = this.state
        // console.log(countryId)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <ExhibitorHeader />
                <ExhibitorDrawer />
                <div className="page">
                    <div className="page-main">
                        <div className="main-content with-dr-container">
                            <div className=" width-dr-nav">
                                <div className="row">
                                    <ExhibitorTopMenu />
                                </div>
                            </div>
                            <div className="card-header p-3">
                                <h3 className="card-title"> Exhibit Details </h3>{<span className='text-danger ml-2' style={{ float: 'left' }}>{exbTableErr}</span>}
                            </div>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-xl-12 p-3">
                                        <div className="card rounded-0">
                                            <div className="card-body p-0">
                                                <div className="row mt-2">
                                                    <div className="col-xl-6">
                                                        <label htmlFor="validationCustom03">
                                                            Name of the Company <span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            disabled={true}
                                                            value={regCompany}
                                                            onChange={(e) => this.setState({ regCompany: e.target.value, regCompanyErr: "" })}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{regCompanyErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <label htmlFor="validationCustom03">
                                                            Fascia Name (Shell Scheme Only)<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            maxLength={'250'}
                                                            disabled={true}
                                                            value={fasciaName}
                                                            onChange={(e) => this.setState({ fasciaName: e.target.value, fasciaNameErr: "" })}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{fasciaNameErr}</span>} */}
                                                    </div>
                                                </div>
                                                <div className="row mt-2">
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            First Name of Person Incharge
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        {
                                                            isOtherPreFixPersonInch &&
                                                            <input
                                                                type="text"
                                                                disabled={true}
                                                                className="form-control-1 other-fil"
                                                                value={otherPersonInchFirst}
                                                                onChange={e => this.setState({ otherPersonInchFirst: e.target.value })}
                                                                placeholder={'Other'}
                                                                style={{
                                                                    // position: "absolute",
                                                                    paddingLeft: '5px'
                                                                }}
                                                            />
                                                        }
                                                        <input
                                                            type="text"
                                                            disabled={true}
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            value={personInchFirst}
                                                            maxLength={'100'}
                                                            onChange={(e) => this.setState({ personInchFirst: e.target.value, personInchFirstErr: "" })}
                                                            style={{
                                                                // position: "absolute",
                                                                paddingLeft: '50px'
                                                            }}
                                                        />
                                                        <div className="col-xl-1 mb-3">
                                                            <div
                                                                className="form-group"
                                                                style={{
                                                                    width: '45px',
                                                                    position: "absolute",
                                                                    top: "-58px",
                                                                    left: '0px'
                                                                }}
                                                            >
                                                                <label />
                                                                <select
                                                                    disabled={true}

                                                                    className="form-control-1 select2 select-hidden-accessible"
                                                                    id="roledb"
                                                                    style={{
                                                                        paddingLeft: '0px',
                                                                        paddingRight: '0px',
                                                                        borderTop: "none",
                                                                        borderBottom: "none",
                                                                        marginTop: '0px',
                                                                        textAlign: "left"
                                                                    }}
                                                                    value={preFixPersonInch}
                                                                    onChange={(e) => this.setState({
                                                                        preFixPersonInch: e.target.value,
                                                                        isOtherPreFixPersonInch: e.target.value == "Other" && true
                                                                    })}
                                                                >
                                                                    <option value="Mr">Mr</option>
                                                                    <option value="Ms">Ms</option>
                                                                    <option value="DR">DR</option>
                                                                    <option value="Prof">Prof</option>
                                                                    <option value="Other">Other</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{personInchFirstErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label>
                                                            Last Name of Person Incharge<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            disabled={true}
                                                            type="text"
                                                            className="form-control"
                                                            maxLength={'100'}
                                                            value={personInchLast}
                                                        // onChange={(e) => this.setState({ personInchLast: e.target.value, personInchLastErr: "" })}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{personInchLastErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            Designation<span className="text-red">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="validationCustom03"
                                                            disabled={true}
                                                            value={regDesignation}
                                                        // onChange={(e) => this.setState({ regDesignation: e.target.value, regDesignationErr: "" })}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{regDesignationErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label htmlFor="validationCustom03">
                                                            Country<span className="text-red">*</span>
                                                        </label>
                                                        <select className="form-control"
                                                            disabled={true}
                                                            value={countryId}
                                                            onChange={e => this.setState({ countryId: e.target.value, })}>
                                                            <option>Select Your Country</option>
                                                            {
                                                                this.state.countryList.length > 0 && this.state.countryList.map((item) => (
                                                                    <option key={item.Code} value={item.Code}>{item.Description}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {/* {isDisplayCountryList && this.renderCountryList()} */}
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{regCountryErr}</span>} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card card-cus card-cus-2 mb-2 cus-width">
                                        <p className="p-3">
                                            Selected Primary Chapter :{" "}
                                            <span>
                                                <spa>{primaryChapterName}</spa>
                                            </span>
                                        </p>
                                        <div
                                            className="card-header cus-hed"

                                        >
                                            <strong>Scheme Type <span className="text-red">*</span></strong>
                                        </div>
                                        <div className="form-row mt-1 p-2">

                                            {
                                                stallTypeIdList.length > 0 && stallTypeIdList.map((stallTypeIdListData) => (
                                                    <div className="col-xl-2">
                                                        <label>
                                                            <input type="radio"
                                                                id={'stallTypeId'}
                                                                name={'stallTypeId'}
                                                                disabled={true}
                                                                radioGroup={stallTypeId == stallTypeIdListData.Code && true}
                                                                select={stallTypeId == stallTypeIdListData.Code && true}
                                                                checked={stallTypeId == stallTypeIdListData.Code && true}
                                                                value={stallTypeId}
                                                            // onChange={e => this.onSchemeTypeChange(e, stallTypeIdListData.Code)}
                                                            />
                                                            {stallTypeIdListData.Description}
                                                        </label>
                                                    </div>
                                                ))
                                            }
                                            {/* {<span className='text-danger '>{stallTypeIdErr}</span>} */}

                                        </div>
                                        <div
                                            className="card-header cus-hed"
                                            style={{

                                                borderTop: "1px solid #eee"
                                            }}
                                        >
                                            <strong>Stall Area <span className="text-red">*</span></strong>
                                        </div>
                                        <div className="form-row mt-1 p-2">
                                            <div className="col-xl-3">
                                                <label>Length * width in Meters</label>
                                                <select
                                                    className="form-control select2 select-hidden-accessible pl-0"
                                                    id="roledb"
                                                    value={stallArea}
                                                    disabled={true}

                                                // onChange={e => this.onLengthTypeChange(e)}
                                                >
                                                    <option value="">Select</option>
                                                    {
                                                        stallAreaList.length > 0 && stallAreaList.map(stallAreaData => (
                                                            <option value={stallAreaData.Code} key={stallAreaData.Code}>{stallAreaData.Description}</option>
                                                        ))
                                                    }


                                                </select>
                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{stallAreaErr}</span>} */}
                                            </div>
                                            {stallArea != '' && stallArea != 'Select' &&
                                                <div className="col-xl-3">
                                                    <label className='mt-4'></label>
                                                    <span><strong>{this.state.area} sqm.</strong></span>
                                                </div>
                                            }
                                        </div>
                                        <div
                                            className="card-header  cus-hed mt-2"
                                            style={{

                                                borderTop: "1px solid #eee",
                                                position: "relative"
                                            }}
                                        >
                                            <strong>
                                                Open Sides (Please Tick the no required) <span className="text-red">*</span>
                                            </strong>
                                        </div>
                                        <div className="form-row mt-1 p-2">
                                            {this.state.openSideList.length > 0 && this.state.openSideList.map(item => (
                                                <>
                                                    {item.OpenSidesID == 4 ? this.state.area >= this.state.minAreafor4OpenSide ? <div className="col-xl-2">
                                                        <label>
                                                            <input type="radio" name="openSlides" value={openSlides}
                                                                checked={openSlides == item.OpenSidesID}
                                                                disabled
                                                                onClick={e => this.setState({ openSlides: item.OpenSidesID, openSlidesErr: '' })} /> {
                                                                item.OpenSideName
                                                            }
                                                        </label>
                                                    </div> : '' : <div className="col-xl-2">
                                                        <label>
                                                            <input type="radio" name="openSlides" value={openSlides}
                                                                checked={openSlides == item.OpenSidesID}
                                                                disabled
                                                                onClick={e => this.setState({ openSlides: item.OpenSidesID, openSlidesErr: '' })} /> {
                                                                item.OpenSideName
                                                            }
                                                        </label>
                                                    </div>}
                                                </>
                                            ))}

                                            {/* <div className="col-xl-2">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '1'}
                                                                                    onClick={e => this.setState({ openSlides: '1', openSlidesErr: '' })} /> 1 Open Side
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-xl-2">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '2'}
                                                                                    onClick={e => this.setState({ openSlides: '2', openSlidesErr: '' })}
                                                                                /> 2 Open Side
                                                                            </label>
                                                                        </div>
                                                                        <div className="col-xl-2 mb-3">
                                                                            <label>
                                                                                <input type="radio" name="openSlides" value={openSlides}
                                                                                    checked={openSlides == '3'}
                                                                                    onClick={e => this.setState({ openSlides: '3', openSlidesErr: '' })} /> 3 Open Side
                                                                            </label>
                                                                        </div> */}
                                            {/* {<span className='text-danger text-start text-left d-block mt-1'>{openSlidesErr}</span>} */}

                                        </div>
                                        {this.state.isDoubleStoreyExhibition && this.state.stallTypeId == 1 && <>
                                            <div
                                                className="card-header  cus-hed mt-2"
                                                style={{

                                                    borderTop: "1px solid #eee",
                                                    position: "relative"
                                                }}
                                            >
                                                <div className="d-flex">
                                                    <input
                                                        className="toggle-box mt-1"
                                                        id="identifier-2"
                                                        type="checkbox"
                                                        style={{ float: "left" }}
                                                        checked={this.state.isDoubleStorey}
                                                        disabled={true}
                                                    // onClick={(e) => this.onCheckdoubleStorey(e)}
                                                    />
                                                    <div >
                                                        <label htmlFor="identifier-2" style={{ fontSize: 16 }}>
                                                            <strong> Double storey </strong>

                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                this.state.isDoubleStorey
                                                &&
                                                <div className="form-row mt-1 p-2">
                                                    <div className="col-xl-3">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            disabled={true}
                                                            maxLength={'10'}
                                                            value={this.state.doubleStoreyArea}
                                                        // onInput={e => this.maxLengthCheck(e, 10)}

                                                        // onChange={e => this.onChangeDoubleStorey(e)}
                                                        />
                                                    </div>
                                                    {/* {<span className='text-danger text-start text-left d-block mt-1'>{this.state.doubleStoreyAreaErr}</span>} */}

                                                </div>}
                                        </>}
                                    </div>

                                    <div className="mt-2">
                                        <div className="col-xl-12 p-1">
                                            <div className="row">
                                                {currentDate > DeadlineDate &&
                                                    <span className="text-danger">THE DEADLINE TO FILL OUT THE FORM HAS PASSED.</span>
                                                }
                                            </div>
                                            <div className="mt-1">
                                                <button className="byn btn-primary rounded p-1"
                                                    style={{ float: "right", marginBottom: "10px", height: "30px", cursor: 'pointer' }}
                                                    disabled={currentDate > DeadlineDate}
                                                    onClick={(e) => this.onAddClick(e)}
                                                >Add Chapter</button>
                                            </div>
                                            <table
                                                className="table table-bordered"
                                                style={{
                                                    border: "1px solid #d8d8d8 !important"
                                                }}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th>Product</th>
                                                        <th>Manufacturer Name<span className="text-red">*</span></th>
                                                        <th>Manufacturing Country<span className="text-red">*</span></th>
                                                        <th>Machine/Brochure</th>
                                                        <th>Machine Details</th>
                                                        <th>HSN Code</th>
                                                        <th colspan="4">Machine Dimension (mtr)</th>
                                                        {/* <th>Length</th>
                                                                                    <th>Breadth</th>
                                                                                    <th>Height</th> */}
                                                        <th>Floor Capacity (Kgs per sq mtr)</th>
                                                        <th>Machine Weight (Kg)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td className="tbody-th-head">Length</td>
                                                        <td className="tbody-th-head">Breadth</td>
                                                        <td className="tbody-th-head">Area</td>
                                                        <td className="tbody-th-head">Height</td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    {
                                                        subChapters.length > 0 ? subChapters.map((data, index) => (
                                                            <tr>
                                                                {data.ChapterID != 0 ? (
                                                                    <td>{data.ChapterName}</td>
                                                                ) : (
                                                                    <td><input
                                                                        type="text"
                                                                        className="form-control"
                                                                        // maxLength={'10'}
                                                                        value={data.ChapterName}
                                                                        // onInput={e => this.maxLengthCheck(e, 10)}
                                                                        onChange={e => this.onEnterProductName(e, index)}
                                                                    /></td>
                                                                )}
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        maxLength={'200'}
                                                                        value={data.ManufacturerName}
                                                                        // onInput={e => this.maxLengthCheck(e, 10)}
                                                                        onChange={e => this.onManufacturerNameChange(e, data.ChapterID, index)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        required=""
                                                                        value={data.ManufacturingCountry}
                                                                        onChange={(e) => this.onManufacturingCountryChange(e, data.ChapterID, index)}
                                                                    />
                                                                    {this.state.isDisplayCountryList && this.state.manufactureCountryIndex == index && this.renderCountryList()}
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <input
                                                                            className="toggle-box mt-1"
                                                                            id="identifier-2"
                                                                            type="checkbox"
                                                                            style={{ float: "left" }}
                                                                            checked={data.isMachine}
                                                                            onClick={(e) => this.onMBclick(0, data.ChapterID, index)}
                                                                        />
                                                                        Machine
                                                                    </div>
                                                                    <div>
                                                                        <input
                                                                            className="toggle-box mt-1"
                                                                            id="identifier-2"
                                                                            type="checkbox"
                                                                            style={{ float: "left" }}
                                                                            checked={data.isBrochure}
                                                                            onClick={(e) => this.onMBclick(1, data.ChapterID, index)}
                                                                        />
                                                                        Brochure
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        maxLength={'200'}
                                                                        value={data.MachineDetails}
                                                                        // onInput={e => this.maxLengthCheck(e, 10)}
                                                                        onChange={e => this.onMachineDetailsChange(e, data.ChapterID, index)}
                                                                    />
                                                                </td>

                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        maxLength={'10'}
                                                                        value={data.HSNCode}
                                                                        onInput={e => this.maxLengthCheck(e, 10)}
                                                                        onChange={e => this.onEnterHSNCode(e, data.ChapterID, index)}
                                                                    />
                                                                </td>

                                                                <td style={{ width: '' }}>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        maxLength={'9'}
                                                                        value={data.Length}
                                                                        onInput={e => this.maxLengthCheck(e, 10)}
                                                                        onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                    />
                                                                    {/* <select
                                                                                                    className="form-control select-hidden-accessible"
                                                                                                    id="roledb"
                                                                                                    value={data.Length}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onLengthChange(e, data.ChapterID, index)}
                                                                                                >
                                                                                                    <option value="0">Select</option>
                                                                                                    {lengthList.length > 0 && lengthList.map((item) => (
                                                                                                        <option value={item.Code}>{item.Description}</option>
                                                                                                    ))}
                                                                                                </select> */}
                                                                </td>
                                                                <td style={{ width: '' }}>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        maxLength={'9'}
                                                                        value={data.Breadth}
                                                                        onInput={e => this.maxLengthCheck(e, 10)}
                                                                        onChange={e => this.onBreadthChange(e, data.ChapterID, index)}
                                                                    />
                                                                    {/* <select
                                                                                                    className="form-control select-hidden-accessible"
                                                                                                    id="roledb"
                                                                                                    value={data.Breadth}
                                                                                                    onInput={e => this.maxLengthCheck(e, 10)}
                                                                                                    onChange={e => this.onBreadthChange(e, data.ChapterID, index)}
                                                                                                >
                                                                                                    <option value="0">Select</option>
                                                                                                    {breadthList.length > 0 && breadthList.map((item) => (
                                                                                                        <option value={item.Code}>{item.Description}</option>
                                                                                                    ))}
                                                                                                </select> */}
                                                                </td>
                                                                <td style={{ width: '' }}>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={data.Area}
                                                                        disabled
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        maxLength={'9'}
                                                                        value={data.Height}
                                                                        onInput={e => this.maxLengthCheck(e, 10)}
                                                                        onChange={e => this.onHeightChange(e, data.ChapterID, index)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        title=' Note :
                                                                                                    1- Very heavy-duty equipment and machinery are not allowed into the Hall and shall be allocated in the external exhibition space.
                                                                                                    2- If any exhibitor wants to show live machinery, please contact the organizer for special arrangements.'
                                                                        className="form-control"
                                                                        maxLength={'9'}
                                                                        value={data.FloorCapacity}
                                                                        onInput={e => this.maxLengthCheck(e, 10)}
                                                                        onChange={e => this.onFloorCapacityChange(e, data.ChapterID, index)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        maxLength={'9'}
                                                                        value={data.MachineWeight}
                                                                        onInput={e => this.maxLengthCheck(e, 10)}
                                                                        onChange={e => this.onMachineWeightChange(e, data.ChapterID, index)}
                                                                    />
                                                                </td>

                                                            </tr>
                                                        )) : <tr >
                                                            <td colSpan={10} className="text-center">Record not available</td></tr>
                                                    }

                                                </tbody>

                                            </table>
                                            {<span className='text-danger text-start text-left d-block mt-1'>{exhibitDetailsTableErr}</span>}
                                            {
                                                ((this.state.isShowInternationalArea) && JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim() == 'india')
                                                // true
                                                &&
                                                <div className="col-xl-12 mb-1">
                                                    <label htmlFor="validationCustom03">
                                                        <strong>International Area<span className="text-red" style={{ marginLeft: '5px', marginTop: '-0px', fontSize: '15px' }}>(The international charges will be apply against the selected International area.)*</span>&emsp;: </strong>
                                                    </label>

                                                    <input
                                                        style={{ width: '250px' }}
                                                        type="text"
                                                        disabled={true}
                                                        value={InternationalArea}
                                                        className="form-control"
                                                        required=""
                                                        onChange={(e) => this.setState({ InternationalArea: e.target.value.replace(/[^0-9]/g, ''), InternationalAreaErr: '' }, () => {
                                                            const totalArea = subChapters.reduce((sum, obj) => sum + obj.Area, 0)
                                                            const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != JSON.parse(sessionStorage.getItem('loginDataSS')).CountryName.toLowerCase().trim())
                                                            const total = filterArray.reduce((sum, obj) => sum + obj.Area, 0)
                                                            // console.log("this.state.area", this.state.area)
                                                            // console.log("totalArea", totalArea)
                                                            // console.log("e.target.value", e.target.value)
                                                            // console.log("total", total)
                                                            const value = e.target.value.replace(/[^0-9]/g, '')
                                                            if (this.state.area < totalArea) {
                                                                this.setState({ exbTableErr: 'Total area of sum cannot be greater than stall area' })
                                                            } else {
                                                                this.setState({ exbTableErr: '' })
                                                            }

                                                            if (value < total || this.state.area < value) {
                                                                this.setState({ InternationalAreaErr: "International area cannot be less than above sum of international area's and cannot be greater than stall area" })
                                                            }
                                                            // const filterArray = subChapters.filter(item => item.ManufacturingCountry.toLowerCase().trim() != 'india')
                                                            // const total = filterArray.reduce((sum, obj) => sum + obj.Area, 0)
                                                        })}
                                                    />{<span className='text-danger' style={{ float: 'left' }}>{InternationalAreaErr}</span>}
                                                </div>
                                            }

                                        </div>
                                        < br />
                                        {
                                            ExhibitDetailsNote.length > 0 && ExhibitDetailsNote.map((data, i) => (
                                                <>{< div style={{ textAlign: 'left' }}>
                                                    <strong>Note: </strong>{data.Description}
                                                </div>
                                                }
                                                    < br />
                                                </>
                                            ))
                                        }
                                        < br />
                                        <div class="col-xl-12 mt-n3">
                                            {/* <p class="mb-3"><strong>Guideline for Machinery Display at Kenyatta International Convention Centre, Nairobi</strong></p>
                                    <p class="mb-3">1.   Display of machinery is allowed only in static mode</p>
                                    <p class="mb-3">2.  Very heavy-duty equipment and machinery are not allowed into the Hall and shall be allocated in the external exhibition space. </p>
                                    <p class="mb-3">3.  Floor load capacity: The floor space can hold 3 tons per sqm inside the hall.</p>
                                    <p class="mb-3">4.  Compressed Air and water supply are not available in the halls.</p>
                                    <p class="mb-3">5.  Loading door dimensions: The length is 9.56 mtr and height is 3.18 mtr.</p>
                                    <p class="mb-3"><strong>Note:</strong> <span class="text-danger"> If  any exhibitor wants to show live machinery, please contact the organizer for special arrangements.</span></p> */}

                                            {isShowMachineryGuidelines ?
                                                <p className="m-0 mt-2">
                                                    <strong>Guideline for Machinery Display at {guidelinesAddress}</strong><br />
                                                    {this.state.guideLines.length > 0 && this.state.guideLines.map((data, i) => (
                                                        <>
                                                            {i + 1}- {data.Description}< br />
                                                        </>
                                                    ))}
                                                </p>
                                                : <></>}

                                            <div class="row mt-4 mb-4">
                                                <form>
                                                    <strong> <label>Remark</label></strong>
                                                    <textarea class="form-control"
                                                        value={Remark}
                                                        onChange={(e) => this.setState({ Remark: e.target.value })}
                                                        maxLength={300}
                                                        rows="3">
                                                    </textarea>
                                                </form>
                                            </div>

                                            <div className="d-flex mb-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary rounded-0 d-block"
                                                    style={{ marginRight: 10 }}
                                                    disabled={currentDate > DeadlineDate}
                                                    onClick={() => this.updateExhibitorDetails()}
                                                >
                                                    Update
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary rounded-0 d-block"
                                                    style={{ marginRight: 10 }}
                                                    onClick={() => this.onCancelClick()}
                                                >
                                                    Back
                                                </button>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>


                        </div>
                        {/* <div class="footer-sec">
          <div class="sdsd">
              <strong>Ownership:</strong> All content, formats and images used on this site are owned or licensed by India ITME Society. You may not copy, reproduce, distribute, publish, display, perform, modify, create derivative works, transmit, or in any other way exploit any part of copyrighted material without permission of the copyright owner. Failure to comply shall result in legal action.
          </div>
      </div>

      <div class="footer-first">
          <div class="container-fluid">
              <div class="footer-first">  ITME All Rights Reserved <i class="fa fa-copyright" aria-hidden="true"></i> 2023  </div>
          </div>
      </div> */}
                    </div>
                </div>
                <Modal isOpen={isOpen} onRequestClose={this.onAddClick}>
                    <div className="modal-dialog">
                        <div className="modal-content" style={{ marginTop: '6em', left: '-8em' }}>
                            <div className="modal-header p-3 pb-1">
                                <h3 className="card-title" style={{ fontSize: 14 }}><strong>Select Below Product</strong>
                                </h3>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" style={{ fontSize: '12px' }}
                                    // data-bs-dismiss="modal"
                                    // aria-label="Close"
                                    onClick={e => this.setState({ isOpen: !isOpen })}
                                />
                            </div>
                            <div className="modal-body" style={{ maxHeight: '400px', overflow: 'auto' }}>
                                <div className="" style={{ paddingLeft: 10 }}>
                                    <form className="needs-validation pb-2" noValidate="">
                                        <div className="form-row">

                                            <div class="accordion" id="accordionExample">
                                                {
                                                    level2.length > 0 && level2.map(level2Data => (
                                                        <>
                                                            {
                                                                <div class="accordion-item">
                                                                    <h2 class="accordion-header" id={'heading_l1_' + level2Data.ChapterID}>
                                                                        <button class={"accordion-button collapsed"}
                                                                            type="button" data-bs-toggle="collapse"
                                                                            data-bs-target={'#collapse_l1_' + level2Data.ChapterID} aria-expanded="false"
                                                                            aria-controls={'collapse_l1_' + level2Data.ChapterID}>
                                                                            {
                                                                                level2Data.IsCheckbox &&
                                                                                <input type="checkbox" className="from-left-sp" name="" key={level2Data.ChapterID}
                                                                                    checked={level2Data.IsSelect}
                                                                                    onClick={e => this.onCheckLevel2(e, level2Data.ChapterID)}
                                                                                />
                                                                            }
                                                                            {level2Data.ChapterName} </button>
                                                                    </h2>
                                                                    {this.record(level2Data, level3, level4)}
                                                                </div>
                                                            }
                                                        </>
                                                    ))
                                                }
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.estimatePop} onRequestClose={() => this.setState({ estimatePop: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content" style={{ marginTop: '6em', left: '-8em' }}>
                            <div className="modal-header" style={{ padding: "7px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    This will be the Revised estimates if you choose to Continue to update
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    onClick={(e) => this.setState({ estimatePop: false })}

                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px" }}>
                                <div className="table-responsive">
                                    {/* <p className="mb-2" style={{ float: "left", color: "#0072ff" }}>
                                                                                    As per Rule no. 7.1,7.2,7.8,7.9,and 7.10 the total rent payable
                                                                                    by us is as follows:
                                                                                </p>
                                                                                <p className="mb-2" style={{ float: "right", color: "#0072ff" }}>
                                                                                    Please refer Rule no. 7.1,7.2,7.8,7.9 and 7.10
                                                                                </p>
                                                                                <p /> */}
                                    <table className="table table-bordered">
                                        <tbody>
                                            {
                                                this.state.newestimateDetails.length > 0 ? this.state.newestimateDetails.map((data) => (
                                                    <tr>
                                                        <th style={{ whiteSpace: data.Description.includes('\n') ? 'pre-line' : '' }}>{data.Description}</th>
                                                        <th>{data.Installment1}</th>
                                                        <th>{data.Installment2}</th>
                                                        <th>{data.OpenSide}</th>
                                                        <th>{data.Total_amt}</th>
                                                    </tr>
                                                )) :
                                                    <>
                                                        <tr className='text-center'><td colSpan={4} className='text-center'>Record not found</td></tr>
                                                    </>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e => this.setState({
                                            isUpdatePerm: true
                                        }, () => this.updateExhibitorDetails()))}
                                    >Update</button>
                                    <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ estimatePop: false })}>cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}

export default withRouter(connect(null, { getExhibitorDetails_action, updateSpacebookingEstimate_action, updateExhibitorDetails_action, getDoubleStoreySSI_action, fill_action })(ExhibitorDetails));